const TRUST_ITEMS = [
  {
    icon: "ri-shield-check-fill",
    title: "Licensed & Insured",
    desc: "Full general liability + workers' comp",
  },
  {
    icon: "ri-award-fill",
    title: "ISA Certified Arborists",
    desc: "Industry-certified tree care experts",
  },
  {
    icon: "ri-timer-flash-fill",
    title: "Same-Day Response",
    desc: "Fast scheduling, emergency available",
  },
  {
    icon: "ri-map-pin-2-fill",
    title: "Locally Owned",
    desc: "Northern Virginia's trusted local team",
  },
  {
    icon: "ri-star-fill",
    title: "200+ Five-Star Reviews",
    desc: "Top-rated on Google, every year",
  },
  {
    icon: "ri-money-dollar-circle-fill",
    title: "Free Written Estimates",
    desc: "No obligation, transparent pricing",
  },
];

export default function TrustBar() {
  return (
    <section className="bg-white border-b-2 border-[#e8632a]/20">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8">
        {/* Section label */}
        <p className="text-center text-[11px] font-black uppercase tracking-[3px] text-gray-400 mb-6">
          Why Northern Virginia Homeowners Choose Us
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {TRUST_ITEMS.map((item, i) => (
            <div
              key={item.title}
              className={`flex flex-col items-center text-center px-2 py-3 rounded-xl transition-all hover:bg-[#f8f6f3] ${
                i < 5 ? "lg:border-r lg:border-gray-100" : ""
              }`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#e8632a]/10 rounded-xl mb-3">
                <i className={`${item.icon} text-[#e8632a] text-xl`}></i>
              </div>
              <h3 className="font-black text-[#1e1e1e] text-xs uppercase tracking-wide leading-tight mb-1">
                {item.title}
              </h3>
              <p className="text-gray-400 text-[11px] leading-tight">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
